// @ts-strict-ignore
import React, { useCallback, useMemo } from 'react';
import { sprintf } from 'sprintf-js';

import { TrackedDropdownMenuItem } from 'components/Page/Header/PageHeaderDropdownMenu';
import { LANGUAGES, LanguageLocale } from 'utils/constants';
import { createCookie } from 'utils/cookies';

type Props = {
  languageLocale: LanguageLocale;
  languageLocaleUrl: string | undefined;
};

export function LanguageSelectionMenuItem({
  languageLocale,
  languageLocaleUrl,
}: Props) {
  const title = useMemo(() => {
    if (!languageLocaleUrl) {
      return sprintf(
        /* TRANSLATORS: Tooltip message letting user know page is not yet
         * translated when hovering over disabled language selection link. */
        getText('This page is not translated in %(languages)s'),
        { languages: LANGUAGES[languageLocale] }
      );
    }

    return '';
  }, [languageLocale, languageLocaleUrl]);

  const select = useCallback(
    () => createCookie('_LOCALE_', languageLocale, 1825),
    [languageLocale]
  );

  const qaId = useMemo(
    () =>
      languageLocaleUrl
        ? `locale-link-${languageLocale}`
        : `disabled-locale-link-${languageLocale}`,
    [languageLocale, languageLocaleUrl]
  );

  return (
    <TrackedDropdownMenuItem
      disabled={!languageLocaleUrl}
      href={languageLocaleUrl || null}
      onClick={select}
      title={title}
      data-qa-id={qaId}
      eventName={languageLocaleUrl ? 'Change Language' : undefined}
      eventProperties={
        languageLocaleUrl ? { locale: languageLocale } : undefined
      }
    >
      {LANGUAGES[languageLocale]}
    </TrackedDropdownMenuItem>
  );
}
